import { useMemo } from 'react';
import { DEFAULT_CURRENCIES, isCryptoCurrency } from '@/helpers/currency';
import { useExchangeAmount } from '@/modules/common';
import { useGetCommonStore } from '@/store';
import { DAILY_CASH_DROPS_TOURNAMENT_NAME } from '../helpers';

export const useTournament = (name: string, minBet?: string) => {
  const useCommonStore = useGetCommonStore();

  const isAuthenticated = useCommonStore.use.isAuthenticated();
  const user = useCommonStore.use.user();

  const isDailyCashDropsTournament = useMemo(
    () => name === DAILY_CASH_DROPS_TOURNAMENT_NAME,
    [name]
  );

  const minDepAmount = useMemo(() => {
    if (!(isDailyCashDropsTournament && minBet)) return 0;
    return minBet.slice(1);
  }, [isDailyCashDropsTournament, minBet]);

  const { exchangeAmountWithCurrency } = useExchangeAmount({
    amount: Number(minDepAmount),
    currencyType: 'fiat',
  });

  const displayAmount = useMemo(() => {
    const isCrypto =
      user?.currency && isCryptoCurrency(DEFAULT_CURRENCIES, user?.currency);

    if (!(isDailyCashDropsTournament && isAuthenticated) || isCrypto)
      return minBet ?? '';

    return exchangeAmountWithCurrency;
  }, [
    isDailyCashDropsTournament,
    minBet,
    user?.currency,
    exchangeAmountWithCurrency,
    isAuthenticated,
  ]);

  return {
    isDailyCashDropsTournament,
    displayAmount,
  };
};
